const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/sro/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        navbarTitle: 'Patientenportal Spital Langenthal',
        welcomeText:
            'Mit dem Patientenportal vom SRO behalten Sie stets den Überblick über Ihre Spitaltermine und haben jederzeit Zugriff auf alle wichtigen Informationen rund um Ihre Gesundheit.',
    },
    __RELATIVE_SOURCE_FILE__
);
